import React from "react";
import autobind from "autobind-decorator";
import PropTypes from "prop-types";

import { PureComponent } from "core/components";
import { SwiperSlide, Swiper, Button } from "core/components/Framework7";

import classes from "./styles.module.css";

class NodeTitleSwiper extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  static get defaultProps() {
    return {
      items: [],
      highlight: true,
      nodeId: null,
      href: null,
      navigation: true,
      swiper: {
        speed: 1000,
        slidesPerView: "auto",
        spaceBetween: 8,
        freeMode: true,
      },
    };
  }

  get initialValue() {
    return this.parseNodeItems();
  }

  /**
   * parse items for show in category
   * @param {Array} items
   */
  parseNodeItems() {
    const { items } = this.props;

    return items.map((item) => {
      return this.parseNodeItem(item);
    });
  }

  /**
   * parse item of category
   * @param {Object} item
   */
  parseNodeItem(item) {
    return {
      id: item.id,
      alt: item.category
        ? item.category.cover
          ? item.category.cover.title
          : null
        : null,
      url: item.category
        ? item.category.cover
          ? item.category.cover.url
          : null
        : null,
      title: item.category ? item.category.title : null,
      link: item.id,
      childrenType: item.childrenType,
    };
  }

  handleNodeClick(nodeId) {
    this.props.onNodeClicked(nodeId);
  }

  renderSwiperSlide() {
    const items = this.initialValue;

    if (!items || items.length == 0) return;

    return items.map((item) => {
      return this.renderSlide(item);
    });
  }

  renderSlide(item) {
    const { highlight, href, nodeId } = this.props;
    const buttonHighlight =
      highlight && item.id == nodeId ? "subnode-swiper-slide-active" : "";

    return (
      <SwiperSlide key={item.id} className={`subnode-swiper-slide ${item.id == nodeId ? "subnode-swiper-slide-active" : ""} ${classes.subNode}`}>
        <Button
          large
          fill
          raised
          round
          href={href || "#"}
          text={item.title}
          className={`${buttonHighlight}`}
          onClick={() => this.handleNodeClick(item.id)}
        />
      </SwiperSlide>
    );
  }

  render() {
    const { swiper, navigation } = this.props;

    return (
      <div className={`${classes.nodeTitleSwiperContainer} subnode-container button-top-full-width`}>
        <Swiper
          block
          className={classes.swiper}
          navigation={navigation}
          params={swiper}
        >
          {this.renderSwiperSlide()}
        </Swiper>
      </div>
    );
  }
}

NodeTitleSwiper.propTypes = {
  items: PropTypes.array,
  swiper: PropTypes.object,
};

export default autobind(NodeTitleSwiper);
